import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "geo-item-search land-ai-detections" }
const _hoisted_2 = { class: "contour-area" }
const _hoisted_3 = { class: "font-sm" }
const _hoisted_4 = { class: "form-group mb0 mr16 ml15" }
const _hoisted_5 = { class: "ws-nowrap" }

import GeoItemSearchCommon from 'src/components/Top/geoItemSearchComponents/GeoItemSearchCommon.vue';
import type { CommonSearchParams } from 'src/models/geoItemSearch';
import { detectionKindsMap, detectionKinds } from 'src/consts/ext_land_ai_result';
import {
  computed,
  onMounted,
  reactive,
  ref,
} from 'vue';
import type { DetectionsIndexParams } from 'src/models/apis/extLandAiDetections/extLandAiDetectionsRequest';

interface SearchParams {
  contourAreaFrom: number | null;
  contourAreaTo: number | null;
}

interface GeoItemSearchLandAiDetectopmsState {
  detectionKindsDefaultValues: string[];
  showContourAreaRange: boolean;
  search: SearchParams;
}

const checkboxKeyPrefix = 'dtcs';


export default /*@__PURE__*/_defineComponent({
  __name: 'GeoItemSearchLandAiDetections',
  emits: ["change"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const initSearchState = (): SearchParams => {
  return {
    contourAreaFrom: null,
    contourAreaTo: null,
  };
};
const state = reactive<GeoItemSearchLandAiDetectopmsState>({
  detectionKindsDefaultValues: ['pothole'],
  showContourAreaRange: false,
  search: initSearchState(),
});
const setInitialSearchParams = () => {
  const params: SearchParams = {
    contourAreaFrom: 3000,
    contourAreaTo: 10000,
  };
  state.search = params;
};
onMounted(setInitialSearchParams);

// computed
const contourAreaRangeDisp = computed(() => {
  if (!state.search.contourAreaFrom && !state.search.contourAreaTo) return '';

  const ret = `${state.search.contourAreaFrom}〜${state.search.contourAreaTo}`.replace('null', '');
  return `（${ret}）`;
});
const commonSearchParams = ref<CommonSearchParams | null>(null);
// methods
const getSearchParams = (): DetectionsIndexParams | null => {
  if (!commonSearchParams.value) return null;

  const {
    searchTypes: detectionKinds,
    tsFrom: startTs,
    tsTo: endTs,
    ...other
  } = commonSearchParams.value;
  return {
    detection_kinds: detectionKinds as string[],
    start_ts: startTs,
    end_ts: endTs,
    road_names: other.roadNameDisps,
    directions: other.directions,
    kp_calc_from: other.kpCalcFrom,
    kp_calc_to: other.kpCalcTo,
    contour_area_from: state.search.contourAreaFrom,
    contour_area_to: state.search.contourAreaTo,
  };
};
const onChange = () => {
  emit('change');
};

// others
__expose({ getSearchParams });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GeoItemSearchCommon, {
      "search-params": commonSearchParams.value,
      "onUpdate:searchParams": _cache[0] || (_cache[0] = ($event: any) => ((commonSearchParams).value = $event)),
      "checkbox-key-prefix": checkboxKeyPrefix,
      "search-types": _unref(detectionKinds),
      "search-type-map": _unref(detectionKindsMap),
      "search-type-default-values": state.detectionKindsDefaultValues,
      "default-days-before": 30,
      onChange: onChange
    }, null, 8, ["search-params", "search-types", "search-type-map", "search-type-default-values"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "title-area",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (state.showContourAreaRange = !state.showContourAreaRange))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["fas mr4", {
        'fa-caret-right': !state.showContourAreaRange,
        'fa-caret-down': state.showContourAreaRange,
      }])
        }, null, 2),
        _cache[5] || (_cache[5] = _createTextVNode(" 閾値", -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(contourAreaRangeDisp.value), 1)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.search.contourAreaFrom) = $event)),
            type: "text",
            class: "ib form-control contour-area-from",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (onChange()))
          }, null, 544), [
            [_vModelText, state.search.contourAreaFrom]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "ib waveline ta-center" }, "〜", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.search.contourAreaTo) = $event)),
            type: "text",
            class: "ib form-control contour-area-to",
            onChange: onChange
          }, null, 544), [
            [_vModelText, state.search.contourAreaTo]
          ])
        ])
      ], 512), [
        [_vShow, state.showContourAreaRange]
      ])
    ])
  ]))
}
}

})